export default "__VITE_ASSET__y89PkYBk__"